var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBulb1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 177,
    height: 177,
    viewBox: "0 0 177 177",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7384",
    "data-name": "Group 7384",
    transform: "translate(-414.094 -6173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7319",
    "data-name": "Group 7319",
    transform: "translate(-1.512 -711.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icons8-idea-500",
    d: "M40.955,3A30.983,30.983,0,0,0,10,33.955c0,10.439,3.982,16.646,7.739,20.959,1.878,2.16,3.692,3.9,4.9,5.481a7.031,7.031,0,0,1,1.806,4.514V85.546a6.224,6.224,0,0,0,6.191,6.191h2.386a8.177,8.177,0,0,0,15.864,0h2.386a6.224,6.224,0,0,0,6.191-6.191V64.909a8.985,8.985,0,0,1,1.87-5.61,63.818,63.818,0,0,1,4.837-5.353c3.732-4.055,7.739-9.746,7.739-19.992A30.983,30.983,0,0,0,40.955,3Zm0,4.127A26.8,26.8,0,0,1,67.782,33.955c0,9.222-3.216,13.438-6.707,17.219a60.742,60.742,0,0,0-5.095,5.739,13.528,13.528,0,0,0-2.644,8V75.227H28.573V64.909a11.454,11.454,0,0,0-2.709-7.029c-1.5-1.951-3.3-3.692-5.03-5.675-3.466-3.974-6.707-8.811-6.707-18.25A26.8,26.8,0,0,1,40.955,7.127ZM32.507,33.89a2.4,2.4,0,0,0-.258.064,2.05,2.05,0,0,0-1.612,1.451,2.073,2.073,0,0,0,.581,2.1l7.674,7.674V71.1h4.127V45.176L50.693,37.5a2.1,2.1,0,0,0-2.966-2.966l-6.771,6.771-6.771-6.771A2.071,2.071,0,0,0,32.507,33.89ZM28.573,79.355H53.336v6.191a2.057,2.057,0,0,1-2.064,2.064H35.151a2.1,2.1,0,0,0-.838,0H30.636a2.057,2.057,0,0,1-2.064-2.064Zm8.835,12.382H44.5a4.08,4.08,0,0,1-7.094,0Z",
    transform: "translate(462.651 6922.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_3",
    "data-name": "Intersection 3",
    d: "M8.336,37.216V11.292L.662,3.617A2.064,2.064,0,0,1,1.694.07,2.423,2.423,0,0,1,1.952.006,2.068,2.068,0,0,1,3.629.651L10.4,7.422,17.172.651a2.1,2.1,0,0,1,2.966,2.966l-7.674,7.675V37.216Z",
    transform: "translate(493.228 6956.384)",
    fill: "#e3334a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_783",
    "data-name": "Ellipse 783",
    transform: "translate(414.094 6173)",
    fill: "transparent",
    stroke: "#e3334a",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 88.5,
    cy: 88.5,
    r: 88.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.5,
    cy: 88.5,
    r: 87.5,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb1);
export default __webpack_public_path__ + "static/media/bulb_1.501b5e95ccf488e5a485155e8723c18a.svg";
export { ForwardRef as ReactComponent };